<div class="login-wrapper loginSpinnerDiv">
    <div class="login-left"></div>
        <div class="login-right">
            <div class="login-container">
                <div class="login-box">
                    <div class="login-logo text-center">
                        <img src="../../../assets/images/logo.png">
                    </div>
                    <h2 class="text-center">Forgot Your Password?</h2>
                    <p class="text-center">No problem. Just enter your email address and we'll email you directions how to reset it.</p>
                    <p-messages [showTransitionOptions]="'300ms'" [hideTransitionOptions]="'200ms'" [(value)]="msgs"></p-messages>
                    <div class="message message-error" [hidden]="!showToggle">
                        <div class="message-wrapper">
                            <span class="message-icon pi pi-times-circle"></span>
                            <p>{{ errorMessage }}</p>
                            <button class="p-message-close" type="button" (click)=closeErrorDiv()>
                                <i class="p-message-close-icon pi pi-times"></i>
                            </button>
                        </div>
                    </div>
                    <form class="mt-4 mb-4" name="forgotPasswordForm" (ngSubmit)="f.valid && forgotPassword(model)" #f="ngForm" novalidate>
                        <div class="p-fluid">
                            <div class="p-field">
                                <label for="email">Email address</label>
                                <input id="email" type="text" name="email" pattern="(^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$)" [(ngModel)]="model.email" #email="ngModel" pInputText [ngClass]="{ 'is-invalid': f.submitted && email.invalid }" required>
                                <div *ngIf="f.submitted && email.invalid" class="invalid-feedback">
                                    <span *ngIf="email.errors.required" class="error-message">
                                        <span class="p-message-icon pi pi-times"></span> Email is required
                                    </span>
                                    <span *ngIf="email.errors.pattern" class="error-message">
                                        <span class="p-message-icon pi pi-times"></span> Email must be a valid email address
                                    </span>
                                </div>
                            </div>
                            <div class="p-field text-right">
                                <a class="redirect-link" href="/login"><b>Back to login</b></a>
                            </div>
                        </div>
                        <div class="loginSpinner">
                            <p-progressSpinner [style]="{width: '50px', height: '50px'}" strokeWidth="5" [hidden]="!showSpinner"></p-progressSpinner>
                        </div>
                        <button pButton label="Submit" class="btn-block mt-2" [disabled]="showSpinner"></button>
                    </form>
                </div>
            </div>
        </div>
    </div>